import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const TechnologyDetail = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Programs
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-computer"></i>
                        </div>
                        <h1>Technology & Skills Program</h1>
                        <p className="program-tagline">Empowering youth with digital skills</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>Our Technology Programs</h2>
                        <p>We offer two specialized programs designed to bring digital literacy and computer skills to rural youth, helping them compete in the modern job market.</p>
                    </section>

                    <div className="food-schemes-grid scroll-animate">
                        <div className="food-scheme-card" onClick={() => navigate('/programs/technology/mobile-camp')}>
                            <div className="scheme-icon">
                                <i className="fas fa-laptop-mobile"></i>
                            </div>
                            <h2>Mobile Computer Camp</h2>
                            <p className="scheme-description">Bringing technology education directly to rural areas with mobile computer labs</p>
                            <div className="scheme-stats">
                                <div className="stat">
                                    <i className="fas fa-map-marked-alt"></i>
                                    <span>Multiple Villages</span>
                                </div>
                                <div className="stat">
                                    <i className="fas fa-users"></i>
                                    <span>Outreach Training</span>
                                </div>
                            </div>
                            <div className="scheme-cta">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>

                        <div className="food-scheme-card" onClick={() => navigate('/programs/technology/training-class')}>
                            <div className="scheme-icon">
                                <i className="fas fa-chalkboard-teacher"></i>
                            </div>
                            <h2>Computer Training Class</h2>
                            <p className="scheme-description">Comprehensive computer courses in our dedicated training centers</p>
                            <div className="scheme-stats">
                                <div className="stat">
                                    <i className="fas fa-user-graduate"></i>
                                    <span>700+ Trained</span>
                                </div>
                                <div className="stat">
                                    <i className="fas fa-certificate"></i>
                                    <span>Free Certification</span>
                                </div>
                            </div>
                            <div className="scheme-cta">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>

                    <section className="program-section scroll-animate">
                        <h2>About Our Technology Program</h2>
                        <p>Digital knowledge opens doors to employment, confidence, and equal opportunity in a modern world. Our technology program focuses on bridging the digital divide by providing free computer training and digital literacy to rural youth.</p>
                        <p>We believe that technological skills are essential in today's job market. Through hands-on training and practical projects, we prepare students for better employment opportunities and help them compete in the digital economy.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>About Our Technology Program</h2>
                        <p>Digital knowledge opens doors to employment, confidence, and equal opportunity in a modern world. Our technology program focuses on bridging the digital divide by providing free computer training and digital literacy to rural youth.</p>
                        <p>We believe that technological skills are essential in today's job market. Through hands-on training and practical projects, we prepare students for better employment opportunities and help them compete in the digital economy.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Achievements</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">700+</div>
                                <div className="achievement-label">Students Trained</div>
                                <p>Successfully completed technology courses</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">95%</div>
                                <div className="achievement-label">Completion Rate</div>
                                <p>Students finishing the full program</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">80%</div>
                                <div className="achievement-label">Employability</div>
                                <p>Improved job prospects after training</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Our Technology Program</h2>
                        <p>Help us provide technology training to more rural youth and bridge the digital divide</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Become a Trainer</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TechnologyDetail;
